



























































































































































































































































import {
  modifyStatusClick,
  staffdel,
  beforeStaffDel,
  getStaffActivateLinkApi,
  createStaffRelateCodeApi,
} from "@/api/staffData";
import { getStaffList, getStaffListData } from "@/api/staff";
import relateDialog from "./relateDialog.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { PageModule } from "@/store/module/page";
import { UserModule } from "@/store/module/user";
import { dateFormat } from "@/utils/timeFormat";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    relateDialog,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searTypeenter = ""; //判断输入时名字还是数字
  searchInfo: any = {
    on_job: -1,
    job_id: -1, // 是否授课默认值是
    key_word: "",
    directly_under: -1,
  };
  tableData = []; //列表数据
  pageSize = 10;
  pageSizeArray = [10, 30, 50];
  total = 0;
  page = 1;
  isteachList = [
    { value: "是", key: 1 },
    { value: "否", key: 2 },
  ];
  drawer = false;
  dialogForm = {};
  onjobList = [
    { value: "在职", key: 1 },
    { value: "离职", key: 2 },
  ];
  effectiveDate: any = {
    disabledDate: (date: any) => {
      return date > Date.now();
    },
  };
  get showRelateButton() {
    return UserModule.userInfo.inst_org_number > 1;
  }
  created() {
    const employeesInfo = PageModule.pageInfo.storeEmployees;
    if (employeesInfo.search_info) {
      this.searchInfo = employeesInfo.search_info;
    }
    if (employeesInfo.page) {
      this.page = employeesInfo.page;
    }
    if (employeesInfo.page_size) {
      this.pageSize = employeesInfo.page_size;
    }
    const _t = this;
    const pageData = PageModule.pageInfo.storeStaff;
    if (pageData.page) {
      _t.page = pageData.page;
    }
    _t.getList(
      {
        page: _t.page,
        page_size: _t.pageSize,
      },
      () => {}
    );
  }
  createStaffCode(val: any) {
    createStaffRelateCodeApi({
      staff_id: val.staff_id,
    }).then((res) => {
      const h: any = this.$createElement;
      const now = dateFormat("YYYY-mm-dd HH:MM:SS", new Date());
      this.$msgbox({
        title: "员工码生成",
        message: h("p", null, [
          h("p", null, `员工码：${res.data.code}`),
          h("p", null, `员工姓名：${val.name}`),
          h("p", null, `生成时间：${now}`),
        ]),
        showCancelButton: false,
        confirmButtonText: "复制员工码",
        confirmButtonClass: "mwow-button-filled success",
      })
        .then(() => {
          navigator.clipboard.writeText(res.data.code).then(() => {
            this.$message({
              type: "success",
              message: "复制成功",
            });
          });
        })
        .catch(() => {});
    });
  }
  edit(e: any) {
    const _t = this as any;
    if (e) {
      _t.$router.push({ name: "editEmployee", query: { id: e.staff_id } });
    } else {
      _t.$router.push({ name: "editEmployee", query: { id: 0 } });
    }
    this.cachePageInfo();
  }
  changeIsNeedCaptcha(e: any) {
    const _t = this as any;
    if (e.is_init == 1) {
      return;
    }
    if (e.on_job == true) {
      _t.$confirm(
        `确定关闭在职状态后，将失去门店权限。`,
        `在职状态 - ${e.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          e.on_job = false;
          _t.modifyStatus(e);
        })
        .catch(() => {});
    } else {
      e.on_job = true;
      _t.modifyStatus(e);
    }
  }
  modifyStatus(e: any) {
    const _t = this as any;
    const on_job = e.on_job ? 1 : 2;
    modifyStatusClick({ staff_id: e.staff_id, on_job: on_job })
      .then((res: any) => {
        if (res.error_code == 0) {
          _t.$message({
            type: "success",
            message: "修改成功!",
          });
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
          e.on_job = !e.on_job;
        }
      })
      .catch(() => {
        this.handleRefresh();
      });
  }
  showInviteTips() {
    this.$alert(
      `员工资料信息已添加，需要员工授权激活加入门店，授权激活链接有效期为24小时，超过24小时后可点击【激活邀请】重新复制链接发送给员工激活。`,
      `提示说明-未激活`,
      {
        confirmButtonText: "我知道了",
      }
    );
  }
  handleInvite(row: { staff_id: number }) {
    getStaffActivateLinkApi({
      staff_id: row.staff_id,
    }).then((res) => {
      const link = res.data.link;
      navigator.clipboard.writeText(link).then(() => {
        this.$message({
          type: "success",
          message:
            "激活链接已复制，该链接有效期为24小时，请发送给员工让及时激活",
        });
      });
    });
  }
  disrelate(row: { name: string; staff_id: number }) {
    const _t = this;
    this.$confirm(
      `确定对${row.name}员工进行解除关联吗？`,
      `解除关联 - ${row.name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        staffdel({ staff_id: row.staff_id }).then((res: any) => {
          if (res.error_code == 0) {
            _t.$message({
              type: "success",
              message: "解除关联成功!",
            });
            _t.getList(
              {
                page: 1,
                page_size: _t.pageSize,
              },
              () => {}
            );
          } else {
            _t.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      })
      .catch(() => {});
  }
  clickstaffdel(e: any) {
    const _t = this as any;
    if (e.on_job) {
      this.$message({
        type: "warning",
        message: "请先将员工设为离职状态再进行删除",
      });
      return false;
    }
    beforeStaffDel({
      staff_id: e.staff_id,
    }).then((res: any) => {
      const studentNum =
        res.data.edu_teacher_student_count +
        res.data.follow_staff_student_count;
      const classNum = res.data.class_num;
      const lessonNum = res.data.lesson_num;
      if (studentNum === 0 && classNum === 0 && lessonNum === 0) {
        _t.$confirm(
          `确定删除后，用户的所有权限将失效，此操作不能撤销。`,
          `删除 - 门店员工`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            iconClass: "mwow-icon-error",
          }
        )
          .then(() => {
            staffdel({ staff_id: e.staff_id }).then((res: any) => {
              if (res.error_code == 0) {
                _t.$message({
                  type: "success",
                  message: "删除成功!",
                });
                _t.getList(
                  {
                    page: 1,
                    page_size: _t.pageSize,
                  },
                  () => {}
                );
              } else {
                _t.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          })
          .catch(() => {});
      } else {
        let msg = "";
        if (studentNum) {
          msg = msg + `${studentNum}个学员，`;
        }
        if (classNum) {
          msg = msg + `${classNum}个班级，`;
        }
        if (lessonNum) {
          msg = msg + `${lessonNum}个课时，`;
        }
        _t.$alert(`该员工有绑定${msg}请先进行解绑`, `删除 - 门店员工`, {
          confirmButtonText: "我知道了",
          confirmButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        });
      }
    });
  }
  handlePagerChange(e: number) {
    const _t = this as any;
    _t.page = e;
    this.cachePageInfo();
    _t.getList(
      {
        page: _t.page,
        page_size: _t.pageSize,
      },
      () => {}
    );
  }
  handlePagerSizeChange(e: number) {
    this.cachePageInfo();
    const _t = this as any;
    _t.pageSize = e;
    _t.getList(
      {
        page: 1,
        page_size: e,
      },
      () => {}
    );
  }
  getList(data: getStaffListData, cb?: Function) {
    const _t = this as any;
    if (_t.searchInfo.key_word) {
      data.key_word = _t.searchInfo.key_word;
    }
    if (_t.searchInfo.on_job >= 0) {
      data.on_job = _t.searchInfo.on_job;
    }
    if (_t.searchInfo.job_id >= 0) {
      data.job_id = _t.searchInfo.job_id;
    }
    if (_t.searchInfo.directly_under >= 0) {
      data.directly_under = _t.searchInfo.directly_under;
    }
    if (_t.searchInfo.resting_time && _t.searchInfo.resting_time.length === 2) {
      data.resignation_time_start =
        _t.searchInfo.resting_time[0].getTime() / 1000;
      data.resignation_time_end =
        _t.searchInfo.resting_time[1].getTime() / 1000 + 24 * 60 * 60 - 1;
    }
    getStaffList(data).then((res: any) => {
      if (res.error_code == 0) {
        if (res.data.list != null) {
          res.data.list.map((item: any) => {
            // item.is_teach_name = item.is_teach == 1 ? "是" : "否";
            item.on_job = item.on_job == 1 ? true : false;
            item.resignation_time = item.resignation_time
              ? dateFormat("YYYY-mm-dd", item.resignation_time * 1000)
              : "-";
          });
        }
        _t.tableData = res.data.list;
        _t.total = res.data.total;
        _t.page = res.data.page;
        if (cb) {
          cb();
        }
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  cachePageInfo() {
    PageModule.SET_PAGE_INFO({
      name: "storeEmployees",
      key: "search_info",
      value: { ...this.searchInfo },
    });
    PageModule.SET_PAGE_INFO({
      name: "storeEmployees",
      key: "page",
      value: this.page,
    });
    PageModule.SET_PAGE_INFO({
      name: "storeEmployees",
      key: "page_size",
      value: this.pageSize,
    });
  }
  closeDrawer() {
    this.cachePageInfo();
    const _t = this as any;
    _t.edit();
  }
  handleSearch() {
    const _t = this as any;
    this.getList(
      {
        page: 1,
        page_size: _t.pageSize,
      },
      () => {}
    );
  }
  handleRefresh() {
    const _t = this as any;
    this.getList(
      {
        page: _t.page,
        page_size: _t.pageSize,
      },
      () => {}
    );
  }
}
